<template>
  <div>
    <DataTable
        ref="dataTable"
        :url="this.api.ACTIONS.UNRESOLVED_EXTRA_HOURS"
        :titles="titles"
        :fields-hidden-add="['created_at', 'updated_at']"
        :fields-hidden-main="['reject_reason','updated_at','created_at','user_id','handler_id','first_name','last_name','approved','user']"
        :fields-extra-main="fieldsExtraMain"
        :enableEdit="false"
        :disableSearch="true"
        :enable-delete="false"
        :enableAdd="false"
        :actions-extra-main="actionsExtraMain"
    />

    <v-dialog v-model="dialog" max-width="800">
      <v-card>
        <v-container>
          <v-form ref="form" v-model="valid" :lazy-validation="lazy">
            <p class="headline">Reject Reason:</p>
            <v-textarea
                :rules="requiredRules"
                v-model="reject_reason"
                placeholder="reject reason"
                style="padding: 0 10px"
                solo
            ></v-textarea>
            <v-btn block color="primary" @click="submit">Submit</v-btn>

          </v-form>
        </v-container>
      </v-card>
    </v-dialog>

  </div>
</template>


<script>
import DataTable from "@/components/wasilni/DataTable";

export default {
  components: {DataTable},
  name: "UnresolvedExtraHours",
  data() {
    return {
      dialog: false,
      snackbar: false,
      message: "",
      valid: true,
      lazy: false,
      loading: false,
      reject_reason: null,
      selected_item: null,
      requiredRules: [(v) => !!v || "الحقل مطلوب"],
    }
  },
  methods: {
    submit() {
      this.dialog = false
      this.selected_item.reject_reason = this.reject_reason;
      this.reject_reason = '';
      this.approveOrReject(this.selected_item, 0);
    },
    approveOrReject(item, answer) {
      if (confirm('Are you sure you want to do this action?')) {
        this.axios
            .put(`extra_hour/${item.id}/approve_or_reject`,
                {
                  'approved': answer,
                }
            )
            .then(() => {
              window.getApp.$emit("SHOW_TOAST", answer ? 'Approved.' : 'Rejected.');
              this.$refs.dataTable.removeItemFromTable(item);
            })
            .catch((err) => {
              try {
                this.message = err.response.data.message;
                window.getApp.$emit("SHOW_TOAST", err.response.data.message, "red");

              } catch (e) {
                window.getApp.$emit("SHOW_TOAST", "حدث خطأ", "red");
              }
            })
            .finally(() => (this.loading = false));
      }
    }
  },
  computed: {
    titles() {
      return {
        id: '#',
        from: 'From',
        to: 'To',
        reason: 'Reason',
        approved: 'Status',
        handler: 'Handler',
        actions: 'Approve/Reject'
      }
    },
    fieldsExtraMain() {
      return {
        name: (value) => value.first_name + ' ' + value.last_name,
        actions: (value) => this.actionsExtraMain()
      }
    },
    actionsExtraMain() {
      return {
        approve: {
          icon: 'check_box',
          action: (item) => {
            this.approveOrReject(item, 1)
          }
        },
        disapprove: {
          icon: 'cancel',
          action: (item) => {
            this.approveOrReject(item, 0)
            // this.dialog = true;
            // this.selected_item = item;
          }
        }
      }
    }

  }


}
</script>

<style scoped>

</style>
